module.exports = __webpack_public_path__ + "img/community.d752fb8d.png";